import Menu from "../data/menu.json";
import isoWeek from "dayjs/plugin/isoWeek";

import { defineStore } from "pinia";
export const useMenuStore = defineStore("menu", () => {
  const data = ref(Menu.data.filter((x) => x.visible));
  const menuRefs = ref({});
  const t = (key, params) => {
    if (!key) return "";
    try {
      const nuxtApp = useNuxtApp();
      const i18n = nuxtApp?.$i18n;
      if (i18n && typeof i18n.t === "function") {
        return i18n.t(key, params);
      }
    } catch {
      // No Nuxt context yet
    }
    return String(key);
  };
  const weeks = ref(3);
  const dayjs = useDayjs();
  dayjs.extend(isoWeek);

  const buildNewReleaseLinks = () => {
    let links = [];
    const currentDate = dayjs();
    for (let i = 0; i < weeks.value; i++) {
      const releaseWeek = currentDate.subtract(i, "weeks");
      const weekNo = releaseWeek.isoWeek(); // Use Day.js to get the week number

      links.push({
        releaseWeek: weekNo,
        releaseYear: releaseWeek.year(),
        label: `${t('order_in_week')} ${weekNo}/${releaseWeek.year()}`,
      });
    }
    return links;
  };
  const releaseLinks = computed(() => buildNewReleaseLinks());
  const addMenu = ({
    key,
    title,
    type,
    badgeValue,
    active,
    visible,
    authOnly,
    children = [],
  }) => {
    data.value.push({
      key,
      title,
      type,
      badgeValue,
      active,
      visible,
      children,
      authOnly,
    });
  };
  const addChildToMenu = (key) => {
    const children = ref([
      {
        path: "/products/search",
        key: "complete_overview",
        query: {
          attribute: {
            status_preorder: { "status preorder": true },
          },
          sort: "arrival_desc",
        },
        title: "Complete overview",
        type: "link",
      },
    ]);
    children.value.push(
      ...releaseLinks.value.map((x) => {
        return {
          path: `/products/search`,
          key: x.label,
          title: x.label,
          type: "link",
          query: {
            releaseWeek: x.releaseWeek,
            releaseYear: x.releaseYear,
          },
          legacy: true,
        };
      })
    );

    const index = data.value.findIndex((x) => x.key === key);
    if (index >= 0) {
      data.value[index].children = children.value;
    }
  };
  const addChildToPromo = (key, children) => {
    const index = data.value.findIndex((x) => x.key === key);
    if (index >= 0) {
      data.value[index].children = children;
    }
  };

  const addChildToCalender = (key, children) => {
    const index = data.value.findIndex((x) => x.key === key);
    if (index >= 0) {
      data.value[index].children = children;
    }
  };

  const setMenuRefs = (key, value) => {
    menuRefs.value[key] = value;
  };

  return {
    data,
    addMenu,
    addChildToMenu,
    addChildToPromo,
    addChildToCalender,
    setMenuRefs,
    menuRefs,
  };
});
